import { defineEvent } from '../types/event';
export var FILTER_CATEGORY_SELECT = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Filter_category_selected'
        }
    ]
});
